import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit(): void {
  }

  partnersLink(){
    var url = this.router.routerState.snapshot.url;
    if(url.includes('home')) {
      document.getElementById('partner').scrollIntoView();
    }
    this.router.navigate(['/home/partner']);
  }
  servicesLink(){
    var url = this.router.routerState.snapshot.url;
    if(url.includes('home')) {
      document.getElementById('service').scrollIntoView();
    }
    this.router.navigate(['/home/service']);
  }
}
